import CellLocation from '../components/Table/components/CellLocation'
import React from 'react'

export const initialFilters = [
    {
        filterGrupName: 'Request Priority',
        field: 'assetIsDown',
        filters: [
            {
                filterName: 'Asset Is Down',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Status',
        field: 'status',
        filters: [
            {
                filterName: 'Received',
                checked: false,
            },
            {
                filterName: 'Scheduled',
                checked: false,
            },
            {
                filterName: 'Repair In Progress',
                checked: false,
            },
            {
                filterName: 'Rescheduled',
                checked: false,
            },
            {
                filterName: 'Repair Back In Progress',
                checked: false,
            },
            // {
            //     filterName: 'Awaiting PO',
            //     checked: false,
            // },
            // {
            //     filterName: 'Canceled',
            //     checked: false,
            // },
            // {
            //     filterName: 'Repair Completed',
            //     checked: false,
            // },
        ],
    },
    {
        filterGrupName: 'Request Type',
        field: 'type',
        filters: [
            {
                filterName: 'Repair',
                checked: false,
            },
            {
                filterName: 'Parts',
                checked: false,
            },
            {
                filterName: 'Rental',
                checked: false,
            },
            {
                filterName: 'Equipment',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Location',
        field: 'shipToId',
        filters: [],
    },
]

const PMstatus = {
    filterGrupName: 'Status',
    field: 'status',
    filters: [
        {
            filterName: 'Received',
            checked: false,
        },
        {
            filterName: 'Scheduled',
            checked: false,
        },
        {
            filterName: 'PM In Progress',
            checked: false,
        },
        {
            filterName: 'Rescheduled',
            checked: false,
        },
        {
            filterName: 'PM Back In Progress',
            checked: false,
        },
    ],
}

const excludedFields = ['type', 'assetIsDown', 'status']

const intialPMFilters = [
    PMstatus,
    ...initialFilters.filter(filter => !excludedFields.includes(filter.field)),
]

const initialEstimateFilters = [
    {
        filterGrupName: 'Status',
        field: 'status',
        filters: [
            {
                filterName: 'Draft',
                checked: false,
            },
            {
                filterName: 'Awaiting Approval',
                checked: false,
            },
            {
                filterName: 'Expired',
                checked: false,
            },
            {
                filterName: 'Declined',
                checked: false,
            },
            {
                filterName: 'Approved',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Location',
        field: 'shipToId',
        filters: [],
    },
]

const initialCompletedFilters = [
    {
        filterGrupName: 'Request Priority',
        field: 'assetIsDown',
        filters: [
            {
                filterName: 'Asset Is Down',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Status',
        field: 'status',
        filters: [
            {
                filterName: 'Awaiting PO',
                checked: false,
            },
            {
                filterName: 'Canceled',
                checked: false,
            },
            {
                filterName: 'Repair Completed',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Location',
        field: 'shipToId',
        filters: [],
    },
]

const renderLocation = (address, name) => (
    <CellLocation address={address} label={name} isInCard />
)

export const getInitialFilters = (
    mylocations,
    windowsParams,
    tabFilters = 'activeTabFilters',
) => {
    let filters =
        tabFilters === 'activeTabFilters'
            ? initialFilters
            : initialCompletedFilters
    return filters?.map(fil => {
        if (fil?.filterGrupName === 'Location') {
            return {
                ...fil,
                filterGrupName: 'Location',
                filters: mylocations?.map(item => {
                    return {
                        checked: false,
                        customRender: () =>
                            renderLocation(item?.address, item?.label),
                        filterName: item?.address,
                        shiptoId: item?.id,
                        isLocation: true,
                    }
                }),
            }
        }
        const windowsParamsKeys = Object.keys(windowsParams || [])
        if (windowsParamsKeys?.includes(fil?.field)) {
            const filterData = {
                ...fil,
                filters: fil?.filters?.map(filter => {
                    return {
                        ...filter,
                        checked:
                            filter?.filterName === windowsParams[fil?.field],
                    }
                }),
            }
            return filterData
        }

        return fil
    })
}

const intialPastPMFilters = [
    ...initialCompletedFilters.filter(filter => filter.field !== 'assetIsDown'),
]

export const getInitialPMFilters = (
    mylocations,
    windowsParams,
    tabFilters = 'activeTabFilters',
) => {
    let filters =
        tabFilters === 'activeTabFilters'
            ? intialPMFilters
            : intialPastPMFilters
    return filters?.map(fil => {
        if (fil?.filterGrupName === 'Location') {
            return {
                ...fil,
                filterGrupName: 'Location',
                filters: mylocations?.map(item => {
                    return {
                        checked: false,
                        customRender: () =>
                            renderLocation(item?.address, item?.label),
                        filterName: item?.address,
                        shiptoId: item?.id,
                        isLocation: true,
                    }
                }),
            }
        }

        const windowsParamsKeys = Object.keys(windowsParams || [])
        if (windowsParamsKeys?.includes(fil?.field)) {
            const filterData = {
                ...fil,
                filters: fil?.filters?.map(filter => {
                    return {
                        ...filter,
                        checked:
                            filter?.filterName === windowsParams[fil?.field],
                    }
                }),
            }
            return filterData
        }

        return fil
    })
}

export const getInitialEstimateFilters = (mylocations, windowsParams) => {
    return initialEstimateFilters?.map(fil => {
        if (fil?.filterGrupName === 'Location') {
            return {
                ...fil,
                filterGrupName: 'Location',
                filters: mylocations?.map(item => {
                    return {
                        checked: false,
                        customRender: () =>
                            renderLocation(item?.address, item?.label),
                        filterName: item?.address,
                        shiptoId: item?.id,
                        isLocation: true,
                    }
                }),
            }
        }

        const windowsParamsKeys = Object.keys(windowsParams || [])
        if (windowsParamsKeys?.includes(fil?.field)) {
            const filterData = {
                ...fil,
                filters: fil?.filters?.map(filter => {
                    return {
                        ...filter,
                        checked:
                            filter?.filterName === windowsParams[fil?.field],
                    }
                }),
            }
            return filterData
        }

        return fil
    })
}
